module.exports = __webpack_public_path__ + "static/media/image01.ce538daf.png";